/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/View',
        'assets/js/modules/designFacePreview/designFacePreview',
        'assets/js/modules/designFacePreview/model/designFacePreviewModel',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/designFacePreview/model/productPreviewInfoModel',
        'assets/js/modules/designFacePreview/guideLines/arrowLegendPresenter'
    ],
    function($, _, View, DesignFacePreview, DesignFacePreviewModel, AttributeModel, ProductPreviewInfoModel, ArrowLegendPresenter) {
        return View.extend({
            maxHeight: null,
            safeGap: null,

            width: null,
            height: null,

            initialize: function(options) {
                this.maxHeight = options.maxHeight || 440;
                this.safeGap = options.safeGap || 10;

                this.updateDimensions();
                this.render();
            },

            resetStyles: function() {
                this.$el.css({
                    width: '100%',
                    height: null
                });
            },

            updateDimensions: function() {
                var elWidth = this.$el.width();
                var width = elWidth;
                var height = this.getHeightByWidth(elWidth);

                // for some reason our booklets dimensions are swapped =\
                if (this.isVertical() && width > height) {
                    height = this.getWidthByHeight(elWidth);
                    if (height > this.maxHeight) {
                        height = this.maxHeight;
                        width = this.getHeightByWidth(height);
                    }
                }

                this.width = width;
                this.height = height;
            },

            render: function() {
                this.drawPlaceholder();
                this.renderGuideLines();
            },

            drawPlaceholder: function() {
                this.$el.css({
                    width: this.width,
                    height: this.height
                });
            },

            renderGuideLines: function() {
                var _this = this;
                // We need to clone model to prevent changing of the source model as it
                // may be used by some other scripts.
                var productPreviewInfo = this.cloneProductPreviewInfo(this.model.get('productPreviewInfo'));
                var zones = productPreviewInfo.get('zones');
                var linearUnitSign = this.model.get('linearUnitSign');
                var realSafeWidth = this.model.get('productPreviewInfo').get('zones').safeWidth;
                var realSafeHeight = this.model.get('productPreviewInfo').get('zones').safeHeight;

                // to show the same gapes between zones for different products
                var width = this.isVertical() ? this.height : this.width;
                var height = this.isVertical() ? this.width : this.height;
                zones.safeWidth = zones.bleedWidth * (width - this.safeGap * 2) / width;
                zones.safeHeight = zones.bleedHeight * (height - this.safeGap * 2) / height;

                var hasTrimLine = this.model.get('hasTrimLine');

                var previewModel = new DesignFacePreviewModel({
                    productPreviewInfo: productPreviewInfo,
                    productSlug: this.model.get('productSlug'),
                    guideLinesOptions: this.getGuideLinesOptions(zones, linearUnitSign, realSafeWidth, realSafeHeight, hasTrimLine)
                });

                new DesignFacePreview({
                    model: previewModel,
                    $target: _this.$el
                }).render();
            },

            /**
             * @param {object} zones
             * @param {string} linearUnitSign
             * @param {number} realSafeWidth
             * @param {number} realSafeHeight
             * @param {boolean} hasTrimLine
             * @returns {object}
             */
            getGuideLinesOptions: function(zones, linearUnitSign, realSafeWidth, realSafeHeight, hasTrimLine) {
                var guideLinesOptions = {
                    bleedZone: {
                        background: '#e7e7e9',
                        legend: {
                            text: 'BLEED SIZE: ' + zones.bleedWidth + linearUnitSign + ' x ' + zones.bleedHeight + linearUnitSign,
                            color: '#008000',
                            presenter: ArrowLegendPresenter
                        }
                    },
                    safeZone: {
                        legend: {
                            text: 'SAFE ZONE: ' + realSafeWidth + linearUnitSign + ' x ' + realSafeHeight + linearUnitSign,
                            color: '#ff0000',
                            presenter: ArrowLegendPresenter
                        }
                    }
                };

                if (hasTrimLine === true) {
                    guideLinesOptions.trimZone = {
                        legend: {
                            text: 'TRIM ZONE: ' + zones.trimWidth + linearUnitSign + ' x ' + zones.trimHeight + linearUnitSign,
                            color: '#4141ff',
                            presenter: ArrowLegendPresenter
                        }
                    };
                }

                return guideLinesOptions;
            },

            /**
             * @returns {boolean}
             */
            isVertical: function() {
                var productOrientation = this.model.get('productPreviewInfo').get('orientation');

                return productOrientation == AttributeModel.VALUE_ORIENTATION_PORTRAIT;
            },

            /**
             * @param {number} height
             * @returns {number}
             */
            getWidthByHeight: function(height) {
                var bleedWidth = this.model.get('productPreviewInfo').get('zones').bleedWidth;
                var bleedHeight = this.model.get('productPreviewInfo').get('zones').bleedHeight;

                return Math.round(height * bleedWidth / bleedHeight);
            },

            /***
             * @param {number} width
             * @returns {number}
             */
            getHeightByWidth: function(width) {
                var bleedWidth = this.model.get('productPreviewInfo').get('zones').bleedWidth;
                var bleedHeight = this.model.get('productPreviewInfo').get('zones').bleedHeight;

                return Math.round(width * bleedHeight / bleedWidth);
            },

            /**
             * @param {ProductPreviewInfoModel} productPreviewInfoModel
             * @returns {ProductPreviewInfoModel}
             */
            cloneProductPreviewInfo: function(productPreviewInfoModel) {
                return new ProductPreviewInfoModel({
                    zones: _.clone(productPreviewInfoModel.get('zones')),
                    mailingGuides: _.clone(productPreviewInfoModel.get('mailingGuides')),
                    shape: productPreviewInfoModel.get('shape'),
                    orientation: productPreviewInfoModel.get('orientation'),
                    hasFoldLine: productPreviewInfoModel.get('hasFoldLine'),
                    folding: _.clone(productPreviewInfoModel.get('folding')),
                    defaultOptions: _.clone(productPreviewInfoModel.get('defaultOptions'))
                });
            }
        });
    }
);
